import React from 'react'
import CardResultsTable from '@Components/Tables/CardResultsTable'
import { CardWithHeader } from '@Components/Tables/CardResults/card-with-header'
import { GetId } from '@App/interfaces/get-id'
import '../index.scss'

interface ExtendedOrCompactCardResultsProps<T> {
    data: T[]
    count: number
    extendedCardType: React.ComponentType<T>
    compactCardType?: CardWithHeader<T>
    compact?: boolean
    noResultsInfo?: React.ReactNode
}

const ExtendedOrCompactCardResults = <T extends GetId>(props: ExtendedOrCompactCardResultsProps<T>) => {
    const { data, count, extendedCardType, compact, compactCardType, noResultsInfo } = props
    const SpecificCompactWorkHeader = compactCardType?.headerType

    return (
        <section className="items-container">
            {compact && SpecificCompactWorkHeader && <SpecificCompactWorkHeader />}
            {compact && compactCardType ? (
                <CardResultsTable data={data} count={count} cardType={compactCardType} noResultsInfo={noResultsInfo} />
            ) : (
                <CardResultsTable data={data} count={count} cardType={extendedCardType} noResultsInfo={noResultsInfo} />
            )}
        </section>
    )
}

export default ExtendedOrCompactCardResults
